<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="back($event)"
  >
    <mat-tab label="Ejecucion O.T">
      <div style="width: 100%; margin-top: 30px">
        <data-table
          [title]="titleOT"
          [columns]="columnasOT"
          [data]="dataOT"
          [configuration]="configurationOT"
          [reloadTable]="recargarTablaOT"
          [params]="params"
          [url]="urlTablaOT"
          (add)="agregarOT($event)"
          (closeOrder)="clickFilaOT($event)"
          (delete)="eliminarOT($event)"
          (edit)="editarOT($event)"
          (print)="print($event)"
          (sendEmail)="sendEmail($event)"
          (addComment)='addCommentService($event)'
          (view)="viewDetailService($event)"
          [headerFilters]="headerFilters"
          [roleId]="roleId"
          [moduleId]="3"
          [subModuleId]="7"          
        ></data-table>
      </div>
    </mat-tab>

    <mat-tab *ngIf="currentState == stateTab.DETAIL && selected.value == 1" label="Detalle">
      <app-work-order-summary [workOrderDetails]="detailsClickRow">
      </app-work-order-summary>
    </mat-tab>

    <mat-tab *ngIf="currentState == stateTab.CLOSEOT && selected.value == 1" label="Cierre O.T">
      <mat-card style="background-color: #ffffff7a">
        <app-close-order
          (bodyOrder)="getBodyOrder($event)"
          [orderId]="orderId"
        ></app-close-order>       
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
